import GoogleMap from 'akasia-components/licencia/DetallesLicencia/map/GoogleMap';
import FalconCloseButton from 'components/common/FalconCloseButton';
import Flex from 'components/common/Flex';
import IconButton from 'components/common/IconButton';
import PageHeader from 'components/common/PageHeader';

import useToken from 'hooks/useToken';
import React, { useEffect, useState } from 'react';
import { Badge, Button, Card, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import { BsFillExclamationTriangleFill } from 'react-icons/bs';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Link, useNavigate, useParams } from 'react-router-dom';

import { useToast } from 'context/providers/ToastProvider';

import ModalCancelarLicencia from './ModalCancelarLicencia';
import SeccionLogs from './SeccionLogs';
import SeccionLogsAkasia from './SeccionLogsAkasia';
import SeccionMovimientosAdministrativos from './SeccionMovimientosAdministrativos';

import SeccionServiciosRelacionados from './DetallesLicencia/SeccionServiciosRelacionados';
import SeccionPrincipalDatos from './DetallesLicencia/SeccionPrincipalDatos';
import SeccionModulosLicenciaCliente from './SeccionModulosLicenciaCliente';
import SeccionUsuariosAkasiaPOS from './SeccionUsuariosAkasiaPOS';
import SeccionComentarios from './DetallesLicencia/SeccionComentarios';
import SeccionOrdenesPagadasLicencia from './DetallesLicencia/SeccionOrdenesPagadasLicencia';
import ErrorBoundary from 'components/common/ErrorBoundary';

const DetallesLicencia = () => {
    const { id } = useParams();

    /**
     * DATA
     */
    const [licencias, setLicencias] = useState({});
    const [infoSuscripcion, setInfoSuscripcion] = useState(null);

    /**
     * Obtiene información de suscripción por licencia
     */
    const obtenerInfoSuscripcionPorLicencia = async (idLicenciaParam, idClienteAkasiaParam) => {
        try {
            const response = await fetch(`/api/Suscripciones/ObtenerSuscripciones?idCliente=${idClienteAkasiaParam || ''}`, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();

                if (data && data.iResponseType === 1 && data.detalles) {
                    let detalles = data.detalles;
                    try {
                        if (typeof detalles === 'string') detalles = JSON.parse(detalles);
                    } catch (e) {
                        // leave as-is
                    }

                    // Los datos reales están en table2, no en el objeto raíz
                    const suscripciones = detalles.table2 || [];

                    // Buscar suscripción que corresponda a esta licencia
                    const suscripcionLicencia = suscripciones.find(s => s.idLicencia === parseInt(idLicenciaParam));

                    if (suscripcionLicencia) {
                        setInfoSuscripcion(suscripcionLicencia);
                    } else {
                        // Si no encuentra específica, tomar la primera suscripción activa como fallback
                        const suscripcionActiva = suscripciones.find(s => s.iStatus === 1 || s.iStatus === 0);
                        setInfoSuscripcion(suscripcionActiva || null);
                    }
                } else {
                    setInfoSuscripcion(null);
                }
            }
        } catch (error) {
            console.error('Error al obtener información de suscripción:', error);
            setInfoSuscripcion(null);
        }
    };
    const [datosOrden, setdatosOrden] = useState({ isLoading: true, idOrden: null });

    /**
     * MENSAJES Y AVISOS
     */
    const [editar, setEditar] = useState(false);
    const [cargando, setCargando] = useState(true);
    const { showErrorToast, showSuccessToast } = useToast();
    const [showModalCancelacion, setShowModalCancelacion] = useState(false);
    const [procesandoModal, setProcesandoModal] = useState(false);
    const [showModalEliminar, setShowModalEliminar] = useState(false);


    /**
     * Akasia POS
     */
    const [polizasRelacionadas, setPolizasRelacionadas] = useState([]);

    const [akasiaPOSWebPaquetes] = useState([]);


    /**
     * AUTENTICACION
     */
    const { token, setToken } = useToken();
    /**
     * Se ha recargado 
     */
    const navigate = useNavigate();

    /**
     * Obtiene las licencias por id
     */
    const getInformacionDetalladaLicenciaByID = async () => {

        setdatosOrden({ isLoading: true, idOrden: null });
        setCargando(true);
        const response = await fetch("/api/licencia/getinformaciondetalladalicenciabyid/?id=" + id, {
            method: 'GET',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .catch((error) => {
                showErrorToast('' + error.message);
                console.log('Hubo un problema con la peticion Fetch:' + error.message);
            });

        if (response.ok) {

            console.log("==== DETALLES LICENCIA ====");

            //console.log(response);
            const data = await response.json();

            console.log(data, "DATA LICENCIA");



            const [
                tablaLicencia,
                tablaSuscripcion

            ] = [
                    data['table1'],
                    data['table2']
                ];


            setLicencias(tablaLicencia[0]);

            // Guardar información de suscripción si existe
            if (tablaSuscripcion && tablaSuscripcion.length > 0) {
                setInfoSuscripcion(tablaSuscripcion[0]);
            } else {
                setInfoSuscripcion(null);
                // Si no hay suscripción en la respuesta, intentar obtenerla por separado
                await obtenerInfoSuscripcionPorLicencia(id, tablaLicencia[0]?.idClienteAkasia);
            }

            //se cambia estado de cargando
            setCargando(false);

            setdatosOrden({ isLoading: false, idOrden: data['table1'][0].idOrden || null });

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            setCargando(false);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
        }
    };

    /**
     * Metodo que elimina una licencia
     */
    const eliminarLicencia = async () => {
        const response = await fetch("/api/licencia/EliminarLicencia/?key=" + id, {
            method: 'DELETE',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            const data = await response.json();
            console.log(data);

            if (data[0].iResponseType == 1) {
                getInformacionDetalladaLicenciaByID();
                showSuccessToast(data[0].vMessage);
                setShowModalEliminar(false)
            } else {
                showErrorToast(data[0].vMessage);
                setShowModalEliminar(false)
            }


        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);

            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    /**
     * Eliminar Licencia
     */
    const onSubmitEliminar = () => {
        eliminarLicencia();
    };

    /**
     * Se ejecuta una vez
     */
    useEffect(() => {
        getInformacionDetalladaLicenciaByID();
    }, [id]);

    return (
        <>

            <PageHeader
                title={"Licencia " + id + " | " + licencias.vDescripcionTipo}
                className="mb-1"
            >

                {
                    datosOrden.isLoading ?
                        <Skeleton width={100} />
                        :
                        <>
                            {datosOrden.idOrden ?
                                <>
                                    Orden <Link to={"/ordenes/detalle/" + datosOrden.idOrden}>#{datosOrden.idOrden}</Link> Asignada
                                </>
                                :
                                <>
                                    <div className="badge badge-soft-warning rounded-pill">
                                        <BsFillExclamationTriangleFill className="mb-1 mr-1" />
                                        <span className="mb-0">&nbsp;Sin Orden Asignada</span>
                                    </div>

                                </>
                            }
                        </>
                }

            </PageHeader>
            {cargando ? (<h3><Spinner className="text-inline" animation="border" variant="primary" /> Cargando...</h3>)
                :
                (<>
                    <Card className="mb-3">
                        <Card.Header className="d-flex flex-between-center">
                            <IconButton
                                onClick={() => navigate(-1)}
                                variant="falcon-default"
                                size="sm"
                                icon="arrow-left"
                            />
                            {licencias.bIsActive == 0 && <h1><Badge bg='danger' className='me-2'>LICENCIA ELIMINADA</Badge></h1>}
                            <Flex>
                                <IconButton
                                    variant="falcon-default"
                                    size="sm"
                                    icon="print"
                                    transform="shrink-2"
                                    iconAlign="middle"
                                    className="d-none d-sm-block me-2"
                                    onClick={() => { window.print() }}
                                >
                                    <span className="d-none d-xl-inline-block ms-1">Imprimir</span>
                                </IconButton>
                                {!licencias.bCancelado && (
                                    !licencias.bIsPeriodoPrueba && (
                                        !editar &&
                                        <>
                                            <IconButton
                                                variant="falcon-danger"
                                                size="sm"
                                                icon="ban"
                                                transform="shrink-2"
                                                iconAlign="middle"
                                                className="d-none d-sm-block me-2"
                                                onClick={() => { setShowModalCancelacion(true) }}
                                            >
                                                <span className="d-none d-xl-inline-block ms-1">Cancelar definitivamente</span>
                                            </IconButton>
                                        </>
                                    )
                                )}
                                {!editar &&
                                    licencias.bIsActive &&
                                    <IconButton
                                        variant="falcon-danger"
                                        size="sm"
                                        icon="trash"
                                        transform="shrink-2"
                                        iconAlign="middle"
                                        className="d-none d-sm-block me-2"
                                        onClick={() => { setShowModalEliminar(true) }}
                                    >
                                        <span className="d-none d-xl-inline-block ms-1">Eliminar Licencia</span>
                                    </IconButton>
                                }


                            </Flex>
                        </Card.Header>
                    </Card>



                    <SeccionPrincipalDatos
                        idLicencia={id}
                        licencias={licencias}

                        setProcesandoModal={setProcesandoModal}
                        procesandoModal={procesandoModal}
                        editar={editar}
                        setEditar={setEditar}


                        getInformacionDetalladaLicenciaByID={getInformacionDetalladaLicenciaByID}

                        setPolizasRelacionadas={setPolizasRelacionadas}

                        akasiaPOSWebPaquetes={akasiaPOSWebPaquetes}

                        infoSuscripcion={infoSuscripcion}
                    />

                    <Row className="g-3 mb-3">
                        <Col lg={12}>
                            <SeccionServiciosRelacionados
                                licencias={licencias}
                                idLicencia={id}

                                // akasiaPOSWebPaquetes={akasiaPOSWebPaquetes}
                                // setAkasiaPOSWebPaquetes={setAkasiaPOSWebPaquetes}

                                setPolizasRelacionadas={setPolizasRelacionadas}
                                polizasRelacionadas={polizasRelacionadas}
                            />
                        </Col>
                    </Row>

                    <Row className="g-3 mb-3">
                        <Col lg={12}>
                            <SeccionModulosLicenciaCliente
                                idLicencia={id}
                                idClienteAkasia={licencias.idClienteAkasia}
                                infoSuscripcion={infoSuscripcion}
                            />
                        </Col>
                    </Row>

                    {licencias.idCatTipoLicencia == 7 && (
                        <Row className="g-3 mb-3">
                            <Col lg={12}>
                                <SeccionUsuariosAkasiaPOS
                                    idLicencia={id}
                                    licencias={licencias}
                                    infoSuscripcion={infoSuscripcion}
                                />
                            </Col>
                        </Row>
                    )}

                    <SeccionLogsAkasia
                        idLicencia={id}
                        uuidLicencia={licencias?.vUUIDLicencia}
                    ></SeccionLogsAkasia>
                    
                    <SeccionLogs
                        idLicencia={id}
                    ></SeccionLogs>

                    {licencias.idCatTipoLicencia != 3 &&
                        <Row className="g-3 mb-3">
                            <Col lg={12}>
                                <Card className="mb-3">
                                    <Card.Header>
                                        <h5 className="mb-0">Mapa - Ubicaci&oacute;n de la licencia</h5>
                                    </Card.Header>
                                    <Card.Body className="border-top p-0">
                                        {cargando ? (
                                            <h3>
                                                <Spinner className="text-inline" animation="border" variant="primary" /> Cargando...
                                            </h3>
                                        ) : (
                                            (licencias.vLatLon || licencias.vLatLonSistema) &&
                                            (() => {
                                                const coordenadas = licencias.vLatLon || licencias.vLatLonSistema;
                                                return (
                                                    <GoogleMap
                                                        initialCenter={{
                                                            lat: parseFloat(coordenadas.split(',')[0]),
                                                            lng: parseFloat(coordenadas.split(',')[1])
                                                        }}
                                                        mapStyle="Default"
                                                        darkStyle="Default"
                                                        className="vh-50"
                                                    >
                                                        <p className="fs--1 mb-0">
                                                            {coordenadas}
                                                        </p>
                                                    </GoogleMap>
                                                );
                                            })()
                                        )}
                                    </Card.Body>
                                    <Card.Footer className="bg-light p-0">

                                    </Card.Footer>
                                </Card>
                            </Col>
                        </Row>
                    }

                    <Row className="g-3 mb-3">
                        <Col lg={12}>
                            <ErrorBoundary>

                                <SeccionMovimientosAdministrativos
                                    idLicencia={id}
                                />
                            </ErrorBoundary>

                        </Col>
                    </Row>

                    <Row className="g-3 mb-3">
                        <Col lg={12}>
                            <ErrorBoundary>
                                <SeccionOrdenesPagadasLicencia idLicencia={id} />
                            </ErrorBoundary>
                        </Col>
                    </Row>

                    <ModalCancelarLicencia
                        setShowModalCancelacion={setShowModalCancelacion}
                        showModalCancelacion={showModalCancelacion}
                        idLicencia={id}
                        getInformacionDetalladaLicenciaByID={getInformacionDetalladaLicenciaByID}
                    ></ModalCancelarLicencia>


                    {showModalEliminar &&
                        <Modal
                            show={showModalEliminar}
                            onHide={() => setShowModalEliminar(false)}
                            size="md"
                            backdrop="static"
                            aria-labelledby="contained-modal-title-vcenter"
                            centered
                        >
                            <Form noValidate onSubmit={onSubmitEliminar}>
                                <Modal.Header>
                                    <Modal.Title >Eliminar Licencia</Modal.Title>
                                    <FalconCloseButton className="btn btn-circle btn-sm transition-base p-0" onClick={() => { setShowModalEliminar(false); }} />
                                </Modal.Header>
                                <Modal.Body>
                                    <h4>&iquest;Est&aacute; seguro que desea eliminar la licencia?</h4>
                                    <Row>
                                        <Col md={12}>
                                            Es importante que contemple que al eliminar una licencia de uso tipo Servidor, se eliminar&aacute;n tambi&eacute;n las p&oacute;lizas que se encuentran vinculadas.
                                        </Col>
                                    </Row>

                                </Modal.Body>
                                <Modal.Footer>
                                    <Button onClick={() => { setShowModalEliminar(false); }} variant='primary' >Cerrar</Button>
                                    <Button type="submit" variant='danger' >Eliminar licencia</Button>
                                </Modal.Footer>
                            </Form>
                        </Modal>
                    }

                </>)
            }

            <SeccionComentarios
                idLicencia={id}
                licencias={licencias}

                cargando={cargando}
            />



        </>
    );
};

export default DetallesLicencia;
